import { sendApiRequest } from "../sendApiRequest";

export async function getEnvironment() {
  try {
    const response = await sendApiRequest<{
      environment: string;
      preview: boolean;
      bypassRegionForwarding: boolean;
      bypassLocaleResolveTo: boolean;
      bypassLocaleLock: boolean;
      bypassLocaleDisable: boolean;
    }>("/environment");
    if (!response) throw new Error("Nil environment returned");
    return response;
  } catch (error) {
    console.error("Error accessing environment type", error);
    throw error;
  }
}
